import { render, staticRenderFns } from "./ModalAddSportTeam.vue?vue&type=template&id=361045f6&"
import script from "./ModalAddSportTeam.vue?vue&type=script&lang=js&"
export * from "./ModalAddSportTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports